import { TOGGLE_LEFT_DRAWER_EVENT } from '../ThemeBase';

export default class MobileMenu {
  constructor(theme, element) {
    this.theme = theme;
    this.element = element;
    this.isOpen = false;

    document.documentElement.addEventListener(TOGGLE_LEFT_DRAWER_EVENT, this.handleToggle);
    
    const toggleButtons = document.querySelectorAll('.mobile-nav__toggle');
    toggleButtons.forEach(button => {
      button.addEventListener('click', function(evt) {
        evt.currentTarget.parentElement.classList.toggle('mobile-nav--expanded');
      });
    });

    this.element.querySelector('.mobile-menu--close-btn').addEventListener('click', (e) => { 
      e.preventDefault(); 
      this.close(); 
    });
  }

  handleToggle = (e) => {
    this.toggle(e.detail.forceOpen)
  }

  close = () => {
    document.body.classList.remove('js-drawer-open');
    document.body.classList.remove('js-drawer-open-left');
    this.isOpen = false;
  }

  open = () => {
    document.body.classList.add('js-drawer-open');
    document.body.classList.add('js-drawer-open-left');
    this.isOpen = true;
  }

  toggle = (forceOpen = undefined) => {
    if (forceOpen === true) {
      this.open();
    } else if (forceOpen === false) {
      this.close();
    } else if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

}
